// Página a la que volver después de iniciar sesión: la autorización de OAuth (Claude.ai o ChatGPT abren /oauth/authorize)
// o un link de un aviso (el botón del WhatsApp lleva al local). Solo se vuelve a rutas propias de la app, nunca a otro
// sitio ni a las páginas de inicio de sesión.
const KEY = "afterLoginPath";

export const rememberReturnPath = (path) => {
    try { sessionStorage.setItem(KEY, path); } catch (error) { /* sin sessionStorage se vuelve al inicio */ }
};

export const takeReturnPath = () => {
    try {
        const path = sessionStorage.getItem(KEY);
        sessionStorage.removeItem(KEY);
        return path && path.startsWith("/") && !path.startsWith("//") && !path.startsWith("/auth/") ? path : null;
    } catch (error) {
        return null;
    }
};
